import {
  createCustomerProblem as createCustomerProblemApi,
  deleteCustomerProblem as deleteCustomerProblemApi,
  listCustomerProblems as listCustomerProblemsApi,
  patchCustomerProblem as patchCustomerProblemApi,
} from '@shared/api/customer-problems';
import type {
  CustomerProblem,
  CustomerProblemCreateRequest,
  CustomerProblemListQuery,
  CustomerProblemPatchRequest,
  PagedCustomerProblems,
} from '@shared/types/customer-problem';

interface ListState {
  data: PagedCustomerProblems | null;
  loading: boolean;
  error: string | null;
}

const listState = $state<ListState>({ data: null, loading: false, error: null });
let listToken = 0;

export const customerProblemListStore = {
  get data(): PagedCustomerProblems | null {
    return listState.data;
  },
  get loading(): boolean {
    return listState.loading;
  },
  get error(): string | null {
    return listState.error;
  },
  async refresh(query: CustomerProblemListQuery): Promise<void> {
    const token = ++listToken;
    listState.data = null;
    listState.loading = true;
    listState.error = null;
    try {
      const data = await listCustomerProblemsApi(query);
      if (token !== listToken) return;
      listState.data = data;
    } catch (err) {
      if (token !== listToken) return;
      listState.error = err instanceof Error ? err.message : String(err);
    } finally {
      if (token === listToken) listState.loading = false;
    }
  },
};

export async function createCustomerProblem(
  body: CustomerProblemCreateRequest,
): Promise<CustomerProblem> {
  return createCustomerProblemApi(body);
}

export async function patchCustomerProblem(
  id: string,
  body: CustomerProblemPatchRequest,
): Promise<CustomerProblem> {
  return patchCustomerProblemApi(id, body);
}

export async function deleteCustomerProblem(id: string): Promise<void> {
  return deleteCustomerProblemApi(id);
}
